
















































import { IBitrixGuest } from "@/@types/admin/guest/user";
import { getBirthday } from "@/services/dateTime/date-time-fofmat";
import { Component, Prop, Vue } from "vue-property-decorator";
import identity_cards from "@/config/identity/identity_cards";

@Component({})
export default class BitrixTableTd extends Vue {
  @Prop({ type: Object, default: null }) guest!: IBitrixGuest;
  @Prop({ type: Number, default: 0 }) i!: number;

  get birthday(): string {
    if (!this.guest.personal_data?.birthday) return "";
    return getBirthday(this.guest.personal_data.birthday);
  }

  get arrival(): string {
    if (!this.guest.stay_data?.arrival) return "";
    return getBirthday(this.guest.stay_data.arrival);
  }

  get departure(): string {
    if (!this.guest.stay_data?.departure) return "";
    return getBirthday(this.guest.stay_data.departure);
  }

  get doc_number(): string {
    if (
      !this.guest.personal_data?.documents ||
      !this.guest.personal_data.documents.number
    )
      return "";

    if (
      this.guest.personal_data.documents.doctype === null ||
      this.guest.personal_data.documents.doctype === undefined
    )
      return this.guest.personal_data.documents.number.slice(0, 20);

    // Паспорт РФ
    if (this.guest.personal_data.documents.doctype == identity_cards[0]._id) {
      const length = this.guest.personal_data.documents.number.length;
      if (length > 4)
        return (
          this.guest.personal_data.documents.number.slice(0, 4) +
          " " +
          this.guest.personal_data.documents.number.slice(4, 20)
        );
    }
    // Свидетельство о рождении
    if (this.guest.personal_data.documents.doctype == identity_cards[4]._id) {
      const str = this.guest.personal_data.documents.number;
      const index = str.search(/\d/);
      if (index != -1)
        return (
          this.guest.personal_data.documents.number.slice(0, index) +
          " " +
          this.guest.personal_data.documents.number.slice(index, 20)
        );
    }

    return this.guest.personal_data.documents.number.slice(0, 20);
  }
}
